"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleToggleRowHeader = void 0;
var handleToggleRowHeader = function (_a) {
    var value = _a.value, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = data.map(function (row, rowIdx) {
        if (row.isColHeader) { //then remove
            var newRow = __assign({}, row);
            delete newRow.isColHeader;
            return newRow;
        }
        else { //else add
            return __assign(__assign({}, row), (rowIdx === 0 ? { isColHeader: true } : {}));
        }
    });
    onChange &&
        onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleToggleRowHeader = handleToggleRowHeader;
